<!--
 - 2021-09-18
 - author: 李坤
 - desc: Label.vue
-->
<template>
    <div class="label-root">
        <span class="label">{{ label }}</span>
        <span class="content"><slot></slot></span>
    </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    props: {
        label: {
            type: String,
            required: true,
        },
    },
});
</script>
<style lang="stylus" scoped>
.label-root
    display flex
    align-items center
    justify-content space-between
    .label
        font-size 16px
        color #9c9c9c
        line-height 24px
    .content
        font-size 16px
        color #222222
        line-height 24px
</style>
